//BUYERS Listing
export const FETCH_KEYWORDS_LISTING_FAILURE = 'FETCH_KEYWORDS_LISTING_FAILURE';
export const FETCH_KEYWORDS_LISTING_SUCCESS = 'FETCH_KEYWORDS_LISTING_SUCCESS';

export const RESET = 'RESET';
